import * as React from "react";
import {motion} from "framer-motion"

function SvgComponent(props) {





  return (
    <svg width={"100%"}  viewBox="0 0 696.68 716.16" {...props}>
      <defs>
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29"
          data-name="New Gradient Swatch copy 29"
          x1={357.24}
          y1={285.77}
          x2={651.06}
          y2={285.77}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#970000" />
          <stop offset={1} stopColor="#a11a1a" />
        </linearGradient>
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-2"
          x1={357.24}
          y1={157.29}
          x2={651.06}
          y2={157.29}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-3"
          x1={619.92}
          y1={214.96}
          x2={628.33}
          y2={214.96}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-4"
          x1={607.65}
          y1={207.87}
          x2={616.06}
          y2={207.87}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-5"
          x1={580.89}
          y1={192.42}
          x2={589.29}
          y2={192.42}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-6"
          x1={568.62}
          y1={185.33}
          x2={577.02}
          y2={185.33}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-7"
          x1={541.86}
          y1={169.88}
          x2={550.26}
          y2={169.88}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-8"
          x1={529.59}
          y1={162.79}
          x2={537.99}
          y2={162.79}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-9"
          x1={502.82}
          y1={147.34}
          x2={511.23}
          y2={147.34}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-10"
          x1={490.55}
          y1={140.25}
          x2={498.96}
          y2={140.25}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-11"
          x1={463.79}
          y1={124.8}
          x2={472.2}
          y2={124.8}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-12"
          x1={451.52}
          y1={117.71}
          x2={459.93}
          y2={117.71}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-13"
          x1={424.76}
          y1={102.26}
          x2={433.16}
          y2={102.26}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-14"
          x1={412.49}
          y1={95.16}
          x2={420.9}
          y2={95.16}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-15"
          x1={385.73}
          y1={79.72}
          x2={394.13}
          y2={79.72}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-16"
          x1={373.46}
          y1={72.62}
          x2={381.86}
          y2={72.62}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-17"
          x1={606.34}
          y1={190.63}
          x2={636.95}
          y2={190.63}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-18"
          x1={622.24}
          y1={201.18}
          x2={631.09}
          y2={201.18}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-19"
          x1={567.29}
          y1={168.08}
          x2={597.89}
          y2={168.08}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-20"
          x1={583.19}
          y1={178.63}
          x2={592.04}
          y2={178.63}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-21"
          x1={579.58}
          y1={175.18}
          x2={610.19}
          y2={175.18}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-22"
          x1={595.48}
          y1={185.73}
          x2={604.33}
          y2={185.73}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-23"
          x1={528.23}
          y1={145.47}
          x2={558.83}
          y2={145.47}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-24"
          x1={544.13}
          y1={156.03}
          x2={552.92}
          y2={156.03}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-25"
          x1={540.52}
          y1={152.57}
          x2={571.13}
          y2={152.57}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-26"
          x1={556.42}
          y1={163.12}
          x2={565.27}
          y2={163.12}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-27"
          x1={489.17}
          y1={122.86}
          x2={519.77}
          y2={122.86}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-28"
          x1={505.07}
          y1={133.45}
          x2={513.81}
          y2={133.45}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-29"
          x1={501.46}
          y1={129.96}
          x2={532.07}
          y2={129.96}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-30"
          x1={517.36}
          y1={140.55}
          x2={526.12}
          y2={140.55}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-31"
          x1={450.11}
          y1={100.25}
          x2={480.71}
          y2={100.25}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-32"
          x1={466.01}
          y1={110.86}
          x2={474.69}
          y2={110.86}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-33"
          x1={462.4}
          y1={107.35}
          x2={493.01}
          y2={107.35}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-34"
          x1={478.3}
          y1={117.96}
          x2={486.99}
          y2={117.96}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-35"
          x1={411.05}
          y1={77.64}
          x2={441.65}
          y2={77.64}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-36"
          x1={426.95}
          y1={88.27}
          x2={435.58}
          y2={88.27}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-37"
          x1={423.34}
          y1={84.74}
          x2={453.95}
          y2={84.74}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-38"
          x1={439.24}
          y1={95.37}
          x2={447.88}
          y2={95.37}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-39"
          x1={371.99}
          y1={55.03}
          x2={402.59}
          y2={55.03}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-40"
          x1={387.89}
          y1={65.68}
          x2={396.46}
          y2={65.68}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-41"
          x1={384.28}
          y1={62.13}
          x2={414.89}
          y2={62.13}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-42"
          x1={400.18}
          y1={72.78}
          x2={408.76}
          y2={72.78}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-43"
          x1={618.62}
          y1={197.72}
          x2={649.23}
          y2={197.72}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-44"
          x1={648.03}
          y1={264.25}
          x2={651.06}
          y2={264.25}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-45"
          x1={634.52}
          y1={208.27}
          x2={643.14}
          y2={208.27}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <linearGradient
          id="contactcard__New_Gradient_Swatch_copy_29-46"
          x1={660.46}
          y1={189.95}
          x2={696.68}
          y2={189.95}
          xlinkHref="#contactcard__New_Gradient_Swatch_copy_29"
        />
        <radialGradient
          id="contactcard__\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_242"
          data-name="\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9 \xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2 242"
          cx={-59.25}
          cy={209.65}
          r={116}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#01c8ef" />
          <stop offset={0.09} stopColor="#03bee9" />
          <stop offset={0.24} stopColor="#08a5d7" />
          <stop offset={0.43} stopColor="#107bbb" />
          <stop offset={0.45} stopColor="#1177b8" />
          <stop offset={1} stopColor="#112564" />
        </radialGradient>
      </defs>
      <g id="contactcard__Layer_2" data-name="Layer 2">
        <g id="contactcard__Layer_1-2" data-name="Layer 1">
          <motion.path
            animate={{x:[0,-15,0],y:[0,18,0]}}
            transition={{duration:5,loop:Infinity}}
            d="M696.68 229.87v201.59c0 6.85-4.81 9.62-10.73 6.2L413.6 280.42c-5.93-3.43-10.74-11.75-10.74-18.59V60.24z"
            fill="#ccc"
            id="contactcard__background2"
          />
          <path
            d="M464.38 425a1.59 1.59 0 01-.8-3l21.54-12.46a8 8 0 004-6.86V386a1.59 1.59 0 113.17 0v16.7a11.15 11.15 0 01-5.54 9.62l-21.54 12.45a1.61 1.61 0 01-.83.23z"
            fill="red"
          />
          <path
            transform="rotate(60.17 454.313 429.11)"
            fill="red"
            d="M447.76 414.98h13.11v28.29h-13.11z"
          />
          <path
            d="M471.21 424.78a10.24 10.24 0 00-4.61-8c-2.55-1.48-4.63-.29-4.64 2.67a10.24 10.24 0 004.61 8c2.56 1.47 4.63.28 4.64-2.67z"
            fill="#c1272d"
          />
          <path
            transform="rotate(60.17 427.082 444.724)"
            fill="red"
            d="M416.46 422.55h21.25v44.37h-21.25z"
          />
          <path
            d="M442.82 428.16l8.3-4.76a17 17 0 016.53 11.37l-8.31 4.76a16.94 16.94 0 01-6.52-11.37z"
            fill="#c1272d"
          />
          <path
            d="M453.83 438.06a16.61 16.61 0 00-7.47-13c-4.15-2.41-7.51-.48-7.53 4.31a16.6 16.6 0 007.47 13c4.15 2.41 7.51.48 7.53-4.31z"
            fill="red"
          />
          <path
            d="M463.47 421.74a1.33 1.33 0 000-2.51 4.8 4.8 0 00-4.35 0 1.33 1.33 0 000 2.51 4.83 4.83 0 004.35 0z"
            fill="#d4ecff"
          />
          <path
            d="M132.88 427.7a1.64 1.64 0 01-.79-.21l-18.86-10.86a5 5 0 01.09-8.68L235.56 341a35.12 35.12 0 0018.26-30.81V158.3a7.36 7.36 0 00-10.89-6.46l-40.75 22.22a1.59 1.59 0 01-1.52-2.79l40.75-22.22A10.53 10.53 0 01257 158.3v151.91a38.27 38.27 0 01-19.9 33.59l-122.25 66.93a1.81 1.81 0 000 3.15l18.87 10.85a1.59 1.59 0 01-.8 3z"
            fill="red"
          />
          <g fill="red">
            <path
              transform="rotate(60.17 197.511 175.66)"
              d="M190.95 161.51h13.11v28.29h-13.11z"
            />
            <path d="M214.41 171.31a10.27 10.27 0 00-4.61-8c-2.56-1.49-4.64-.29-4.65 2.66a10.28 10.28 0 004.62 8c2.55 1.49 4.63.3 4.64-2.66z" />
          </g>
          <path
            transform="rotate(60.17 170.276 191.266)"
            fill="red"
            d="M159.66 169.09h21.25v44.37h-21.25z"
          />
          <path
            d="M186 174.69l8.31-4.76a17 17 0 016.52 11.38l-8.3 4.76a17 17 0 01-6.53-11.38z"
            fill="#c1272d"
          />
          <path
            d="M197 184.6a16.61 16.61 0 00-7.47-13c-4.14-2.4-7.51-.47-7.52 4.32a16.59 16.59 0 007.47 13c4.16 2.4 7.52.47 7.52-4.32z"
            fill="#911d22"
          />
          <path
            d="M206.67 168.28a1.33 1.33 0 000-2.51 4.78 4.78 0 00-4.34 0 1.32 1.32 0 000 2.51 4.8 4.8 0 004.34 0z"
            fill="#d4ecff"
          />
          <g fill="red">
            <path
              transform="rotate(119.83 136.21 427.335)"
              d="M129.66 413.18h13.11v28.29h-13.11z"
            />
            <path d="M119.32 423a10.24 10.24 0 014.61-8c2.55-1.48 4.63-.29 4.64 2.66a10.24 10.24 0 01-4.61 8c-2.56 1.47-4.63.28-4.64-2.66z" />
          </g>
          <path
            transform="matrix(-.5 .87 -.87 -.5 629.01 521.5)"
            fill="red"
            d="M152.82 420.76h21.25v44.37h-21.25z"
          />
          <path
            d="M147.71 426.37l-8.3-4.77a17 17 0 00-6.53 11.4l8.31 4.76a16.94 16.94 0 006.52-11.39z"
            fill="#c1272d"
          />
          <path
            d="M136.7 436.27a16.6 16.6 0 017.47-13c4.15-2.41 7.51-.48 7.53 4.31a16.61 16.61 0 01-7.47 13c-4.15 2.42-7.51.48-7.53-4.31z"
            fill="red"
          />
          <path
            d="M127.06 420a1.33 1.33 0 010-2.51 4.8 4.8 0 014.35 0 1.33 1.33 0 010 2.51 4.8 4.8 0 01-4.35 0z"
            fill="#d4ecff"
          />
          <g>
            <path
              d="M361.86 686.19l-271-156.45c-7.66-4.43-6.7-12.16 2.15-17.27L277.54 406c8.85-5.11 22.24-5.66 29.91-1.24l271 156.46c7.66 4.42 6.7 12.15-2.15 17.26L391.77 685c-8.85 5.06-22.24 5.62-29.91 1.19z"
              fill="#ccc"
            />
            <path
              d="M583.61 532l-37.05-4.89L307.45 389c-7.67-4.43-21.06-3.87-29.91 1.24l-169.43 97.81-22.4-2.95v12.71c-.15 2.94 1.53 5.76 5.14 7.85l271 156.45c7.67 4.43 21.06 3.87 29.91-1.24l184.53-106.49c5-2.88 7.46-6.58 7.32-10.06z"
              fill="#333"
            />
            <path d="M403.94 444.74l-17-9.81H200.18l-92.07 53.12-22.4-2.95v12.71c-.15 2.94 1.53 5.76 5.14 7.85l271 156.45c4.05 2.34 9.7 3.28 15.43 2.9z" />
            <path
              d="M95.65 486.41l-9.94-1.31v12.71c-.15 2.94 1.53 5.76 5.14 7.85l4.78 2.76z"
              fill="#333"
            />
            <path
              d="M364.59 663.38c7.26 2.76 17.65 2.16 25.41-1.58v-28.34h-25.41z"
              fill="#1a1a1a"
            />
            <path
              d="M361.86 649.42L90.87 493c-7.66-4.42-6.7-12.15 2.15-17.26L277.54 369.2c8.85-5.11 22.24-5.67 29.91-1.24l271 156.45c7.66 4.43 6.7 12.16-2.15 17.27l-184.53 106.5c-8.85 5.11-22.24 5.67-29.91 1.24z"
              fill="#333"
            />
            <path
              d="M576.29 537L391.77 643.54c-8.85 5.11-22.24 5.66-29.91 1.24l-271-156.46a10.07 10.07 0 01-4.76-5.21c-1.2 3.63.33 7.29 4.76 9.86l271 156.45c7.67 4.43 21.06 3.87 29.91-1.24l184.52-106.5c6-3.43 8.32-8 6.91-12-.87 2.59-3.2 5.21-6.91 7.32z"
              fill="#fff"
            />
            <g fill="#ccc">
              <path d="M206.13 441.17l-12.26-7.08c-1-.57-.87-1.56.27-2.22l14.47-8.35a4.25 4.25 0 013.84-.16l12.27 7.08c1 .57.86 1.56-.28 2.21L210 441a4.25 4.25 0 01-3.87.17zM225.06 452.1L212.8 445c-1-.57-.86-1.56.28-2.22l14.47-8.35a4.25 4.25 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.28 2.22l-14.47 8.35a4.25 4.25 0 01-3.84.18zM244 463l-12.26-7c-1-.56-.87-1.56.27-2.21l14.47-8.36a4.25 4.25 0 013.84-.16l12.27 7.08c1 .57.86 1.56-.28 2.22l-14.47 8.35a4.25 4.25 0 01-3.84.08zM270.18 454l-12.26-7.08c-1-.57-.86-1.56.28-2.22l12.15-7a4.28 4.28 0 013.84-.15l12.26 7.07c1 .57.86 1.57-.28 2.22l-12.14 7a4.34 4.34 0 01-3.85.16zM289.12 464.94l-12.26-7.08c-1-.57-.86-1.56.27-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.26 7.08c1 .56.87 1.56-.27 2.21l-12.15 7a4.28 4.28 0 01-3.84.17zM308.05 475.87l-12.26-7.08c-1-.57-.86-1.56.28-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.28 2.22l-12.15 7a4.25 4.25 0 01-3.84.16zM327 486.8l-12.26-7.08c-1-.57-.86-1.56.27-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.27 2.22l-12.15 7a4.25 4.25 0 01-3.84.16zM345.92 497.73l-12.26-7.08c-1-.56-.86-1.56.28-2.21l12.15-7a4.31 4.31 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.28 2.22l-12.15 7a4.25 4.25 0 01-3.84.15zM364.86 508.67l-12.26-7.08c-1-.57-.86-1.56.27-2.22l12.15-7a4.28 4.28 0 013.84-.15l12.26 7.07c1 .57.86 1.57-.27 2.22l-12.15 7a4.31 4.31 0 01-3.84.16zM383.79 519.6l-12.26-7.08c-1-.57-.86-1.56.28-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.26 7.08c1 .56.86 1.56-.28 2.21l-12.15 7a4.28 4.28 0 01-3.84.17zM402.73 530.53l-12.26-7.08c-1-.57-.86-1.56.27-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.27 7.07c1 .57.86 1.56-.27 2.22l-12.15 7a4.25 4.25 0 01-3.85.17zM421.66 541.46l-12.26-7.08c-1-.57-.86-1.56.28-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.28 2.22l-12.15 7a4.25 4.25 0 01-3.84.16zM440.6 552.39l-12.26-7.08c-1-.56-.86-1.56.27-2.21l12.15-7a4.31 4.31 0 013.84-.16l12.26 7.06c1 .57.86 1.56-.27 2.22l-12.15 7a4.25 4.25 0 01-3.84.17zM298.08 448.83l-12.26-7.08c-1-.57-.86-1.56.28-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.28 2.22l-12.15 7a4.25 4.25 0 01-3.84.16zM278.87 437.73l-12.27-7.07c-1-.57-.86-1.57.28-2.22l12.15-7a4.31 4.31 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.27 2.22l-12.15 7a4.28 4.28 0 01-3.84.15zM259.62 426.62l-26.41-15.25c-1-.56-.86-1.56.28-2.21l12.14-7a4.34 4.34 0 013.85-.16l26.4 15.25c1 .57.86 1.56-.27 2.22l-12.15 7a4.25 4.25 0 01-3.84.15zM273.07 413.11l-21.43-12.38c-1-.57-.86-1.56.28-2.21l12.15-7a4.28 4.28 0 013.84-.16l21.43 12.38c1 .56.86 1.56-.28 2.21l-12.15 7a4.31 4.31 0 01-3.84.16zM317 459.76l-12.26-7.08c-1-.57-.86-1.56.27-2.21l12.15-7a4.25 4.25 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.27 2.22l-12.15 7a4.25 4.25 0 01-3.84.15zM336 470.69l-12.26-7.08c-1-.56-.86-1.56.28-2.21l12.15-7a4.31 4.31 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.28 2.22l-12.15 7a4.25 4.25 0 01-3.84.15zM354.89 481.63l-12.26-7.08c-1-.57-.86-1.56.27-2.22l12.15-7a4.28 4.28 0 013.84-.15l12.26 7.07c1 .57.86 1.57-.27 2.22l-12.15 7a4.31 4.31 0 01-3.84.16zM373.82 492.56l-12.26-7.08c-1-.57-.86-1.56.28-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.28 2.21l-12.15 7a4.28 4.28 0 01-3.84.17zM392.76 503.49l-12.26-7.08c-1-.57-.86-1.56.27-2.22l12.15-7a4.25 4.25 0 013.84-.16L409 494.1c1 .57.86 1.56-.27 2.22l-12.15 7a4.25 4.25 0 01-3.82.17zM411.69 514.42l-12.26-7.08c-1-.57-.86-1.56.28-2.21l12.15-7a4.25 4.25 0 013.84-.16L428 505c1 .57.86 1.56-.28 2.22l-12.15 7a4.25 4.25 0 01-3.88.2zM430.63 525.35l-12.26-7.08c-1-.56-.86-1.56.27-2.21l12.15-7a4.31 4.31 0 013.84-.16l12.26 7.1c1 .57.86 1.56-.27 2.22l-12.15 7a4.25 4.25 0 01-3.84.13zM449.56 536.29l-12.26-7.08c-1-.57-.86-1.56.28-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.26 7.07c1 .57.86 1.57-.28 2.22l-12.15 7a4.31 4.31 0 01-3.84.17zM468.5 547.22l-12.26-7.08c-1-.57-.87-1.56.27-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.27 2.21l-12.15 7a4.28 4.28 0 01-3.84.17zM502.16 566.65l-26.75-15.44c-1-.57-.87-1.56.27-2.22l12.15-7a4.25 4.25 0 013.84-.16l26.75 15.44c1 .57.86 1.56-.27 2.22l-12.15 7a4.25 4.25 0 01-3.84.16zM539 545.37l-22.58-13c-1-.57-.86-1.56.28-2.22l12.15-7a4.25 4.25 0 013.84-.16l22.58 13c1 .57.86 1.56-.28 2.22l-12.15 7a4.25 4.25 0 01-3.84.16zM350.18 457.62l-12.26-7.08c-1-.56-.86-1.56.27-2.21l12.15-7a4.28 4.28 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.27 2.22l-12.15 7a4.25 4.25 0 01-3.84.15zM330.77 446.42l-12.26-7.08c-1-.57-.86-1.56.28-2.22l12.14-7a4.27 4.27 0 013.85-.16L347 437c1 .57.86 1.56-.28 2.22l-12.15 7a4.25 4.25 0 01-3.8.2zM311.37 435.21l-12.27-7.07c-1-.57-.86-1.57.28-2.22l12.15-7a4.31 4.31 0 013.84-.16l12.26 7.08c1 .57.86 1.57-.28 2.22l-12.14 7a4.28 4.28 0 01-3.84.15zM292 424l-12.26-7.08c-1-.57-.86-1.56.27-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.26 7.08c1 .57.87 1.56-.27 2.22l-12.15 7a4.25 4.25 0 01-3.84.16zM369.11 468.55l-12.26-7.07c-1-.57-.86-1.57.28-2.22l12.15-7a4.31 4.31 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.28 2.22l-12.15 7a4.28 4.28 0 01-3.84.15zM388.05 479.49l-12.26-7.08c-1-.57-.87-1.56.27-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.26 7.08c1 .56.86 1.56-.27 2.21l-12.15 7a4.31 4.31 0 01-3.84.17zM407 490.42l-12.26-7.08c-1-.57-.86-1.56.28-2.22l12.14-7A4.27 4.27 0 01411 474l12.25 7c1 .57.86 1.56-.28 2.22l-12.15 7a4.25 4.25 0 01-3.82.2zM425.92 501.35l-12.26-7.08c-1-.57-.87-1.56.27-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.26 7.11c1 .57.86 1.56-.27 2.22l-12.15 7a4.25 4.25 0 01-3.84.13zM444.85 512.28l-12.26-7.08c-1-.56-.86-1.56.28-2.21L445 496a4.3 4.3 0 013.85-.16l12.26 7.08c1 .57.86 1.56-.28 2.22l-12.15 7a4.25 4.25 0 01-3.83.14zM463.79 523.21l-12.27-7.07c-1-.57-.86-1.57.28-2.22l12.15-7a4.31 4.31 0 013.84-.16l12.26 7.08c1 .57.86 1.57-.27 2.22l-12.15 7a4.28 4.28 0 01-3.84.15zM482.72 534.15l-12.26-7.08c-1-.57-.86-1.56.28-2.22l12.14-7a4.25 4.25 0 013.84-.16l12.28 7.07c1 .56.86 1.56-.28 2.21l-12.15 7a4.28 4.28 0 01-3.85.18zM501.66 545.08L489.39 538c-1-.57-.86-1.56.28-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.28 2.22l-12.14 7a4.25 4.25 0 01-3.84.16zM520.59 556l-12.26-7.08c-1-.57-.86-1.56.28-2.22l12.14-7a4.25 4.25 0 013.84-.16l12.27 7.08c1 .57.86 1.56-.28 2.22l-12.15 7a4.25 4.25 0 01-3.84.16zM340.21 430.58L328 423.5c-1-.56-.87-1.56.27-2.21l12.15-7a4.28 4.28 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.27 2.22l-12.15 7a4.25 4.25 0 01-3.89.15zM321.37 419.71l-12.26-7.08c-1-.57-.87-1.56.27-2.22l12.15-7a4.28 4.28 0 013.84-.15l12.26 7.07c1 .57.86 1.57-.27 2.22l-12.15 7a4.31 4.31 0 01-3.84.16zM302.53 408.83l-12.27-7.08c-1-.57-.86-1.56.28-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.28 2.21l-12.14 7a4.28 4.28 0 01-3.84.17zM283.69 398l-12.27-7.08c-1-.57-.86-1.56.28-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.31 7.02c1 .57.86 1.56-.28 2.22l-12.14 7a4.25 4.25 0 01-3.89.22zM303.06 386.76l-12.26-7.07c-1-.57-.86-1.57.27-2.22l4-2.32a4.25 4.25 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.27 2.22l-4 2.32a4.28 4.28 0 01-3.84.15zM327.65 401l-12.27-7.08c-1-.57-.86-1.56.28-2.22l4-2.32a4.28 4.28 0 013.84-.15l12.26 7.07c1 .57.86 1.57-.28 2.22l-4 2.32a4.25 4.25 0 01-3.83.16zM346.41 411.79l-12.26-7.08c-1-.57-.86-1.56.27-2.21l4-2.32a4.25 4.25 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.28 2.21l-4 2.32a4.25 4.25 0 01-3.83.16zM365.17 422.62l-12.26-7.07c-1-.57-.86-1.57.27-2.22l4-2.32a4.25 4.25 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.27 2.22l-4 2.32a4.28 4.28 0 01-3.84.15zM383.93 433.46l-12.26-7.08c-1-.57-.86-1.56.28-2.22l4-2.32a4.28 4.28 0 013.84-.16l12.26 7.08c1 .57.87 1.56-.27 2.22l-4 2.32a4.28 4.28 0 01-3.85.16zM488.68 493.93l-12.26-7.08c-1-.57-.86-1.56.27-2.21l4-2.32a4.25 4.25 0 013.84-.16l12.26 7.08c1 .56.86 1.56-.28 2.21l-4 2.32a4.25 4.25 0 01-3.83.16zM507.44 504.76l-12.26-7.07c-1-.57-.86-1.57.27-2.22l4-2.32a4.25 4.25 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.27 2.22l-4 2.31a4.25 4.25 0 01-3.84.16zM526.2 515.6l-12.26-7.08c-1-.57-.86-1.56.28-2.22l4-2.32a4.28 4.28 0 013.84-.16l12.26 7.08c1 .57.87 1.56-.27 2.22l-4 2.32a4.31 4.31 0 01-3.85.16zM545 526.43l-12.26-7.08c-1-.57-.86-1.56.28-2.22l4-2.32a4.31 4.31 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.28 2.22l-4 2.32a4.25 4.25 0 01-3.84.16zM359.14 441.52l-12.26-7.08c-1-.57-.86-1.57.28-2.22l12.14-7a4.3 4.3 0 013.85-.15l12.26 7.07c1 .57.86 1.57-.28 2.22l-12.15 7a4.31 4.31 0 01-3.84.16zM378.08 452.45l-12.26-7.08c-1-.57-.87-1.56.27-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.26 7.08c1 .56.86 1.56-.27 2.21l-12.15 7a4.28 4.28 0 01-3.84.17zM397 463.38l-12.26-7.08c-1-.57-.86-1.56.28-2.22l12.14-7a4.27 4.27 0 013.85-.16l12.27 7.08c1 .57.86 1.56-.28 2.22l-12.15 7a4.25 4.25 0 01-3.85.16zM416 474.31l-12.27-7.08c-1-.57-.86-1.56.28-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.27 2.22l-12.15 7a4.25 4.25 0 01-3.84.16zM434.88 485.24l-12.26-7.08c-1-.56-.86-1.56.28-2.21l12.14-7a4.31 4.31 0 013.84-.16l12.27 7.08c1 .57.86 1.56-.28 2.22l-12.15 7a4.25 4.25 0 01-3.84.15zM453.82 496.17l-12.27-7.07c-1-.57-.86-1.56.28-2.22l12.15-7a4.28 4.28 0 013.84-.15l12.26 7.07c1 .57.86 1.57-.27 2.22l-12.15 7a4.28 4.28 0 01-3.84.15zM472.75 507.11L460.49 500c-1-.57-.86-1.56.27-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.25 7.1c1 .56.86 1.56-.28 2.21l-12.15 7a4.28 4.28 0 01-3.82.18zM491.69 518l-12.27-7c-1-.57-.86-1.56.28-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.31 7.03c1 .57.86 1.56-.28 2.22l-12.14 7a4.25 4.25 0 01-3.89.13zM510.62 529l-12.26-7.08c-1-.57-.86-1.56.27-2.22l12.15-7a4.25 4.25 0 013.84-.16l12.27 7.08c1 .57.86 1.56-.28 2.22l-12.15 7a4.25 4.25 0 01-3.84.16zM250.89 442.86L214.78 422c-1-.57-.86-1.56.27-2.22l12.15-7a4.28 4.28 0 013.84-.15l36.11 20.84c1 .57.86 1.57-.27 2.22l-12.15 7a4.28 4.28 0 01-3.84.17zM483.51 577.17l-36.11-20.85c-1-.57-.86-1.56.27-2.22l12.15-7a4.25 4.25 0 013.84-.16l36.11 20.85c1 .56.86 1.56-.27 2.21l-12.15 7a4.28 4.28 0 01-3.84.17zM407.78 557.6l-12.26-7.08c-1-.57-.86-1.56.28-2.22l14.47-8.36a4.31 4.31 0 013.84-.16l12.26 7.08c1 .57.86 1.56-.27 2.22l-14.48 8.36a4.31 4.31 0 01-3.84.16zM270.28 478.21l-19.61-11.32c-1-.57-.86-1.56.28-2.22l14.47-8.36a4.31 4.31 0 013.84-.16l19.61 11.33c1 .56.86 1.56-.28 2.21l-14.47 8.36a4.28 4.28 0 01-3.84.16zM389.54 547.06l-19.61-11.32c-1-.57-.86-1.56.28-2.22l14.47-8.35a4.25 4.25 0 013.84-.16l19.61 11.32c1 .57.86 1.56-.28 2.22l-14.47 8.35a4.25 4.25 0 01-3.84.16zM297.6 494L278 482.66c-1-.57-.86-1.56.27-2.22l14.48-8.35a4.25 4.25 0 013.84-.16l19.61 11.32c1 .57.86 1.56-.28 2.22l-14.47 8.35a4.25 4.25 0 01-3.85.18z" />
              <path d="M296.71 472L382 521.22a1.17 1.17 0 010 2.22L367.21 532a4.24 4.24 0 01-3.83 0l-85.26-49.22zM460.7 577.42l13.66 7.88c.81.47.71 1.28-.22 1.82l-5.92 3.42a3.52 3.52 0 01-3.15.13l-13.66-7.89c-.81-.46-.71-1.28.23-1.81l5.92-3.42a3.46 3.46 0 013.14-.13zM441.61 566.39l13.66 7.89c.81.47.71 1.28-.23 1.82l-5.92 3.42a3.55 3.55 0 01-3.15.13l-13.65-7.89c-.81-.47-.71-1.28.22-1.82l5.92-3.42a3.55 3.55 0 013.15-.13zM422.68 555.46l13.65 7.89c.81.46.71 1.28-.22 1.82l-5.92 3.41a3.48 3.48 0 01-3.15.13l-13.66-7.88c-.8-.47-.7-1.28.23-1.82l5.92-3.42a3.51 3.51 0 013.15-.13zM452.07 560.36l13.66 7.88c.8.47.7 1.28-.23 1.82l-5.92 3.42a3.51 3.51 0 01-3.15.13l-13.66-7.89c-.8-.46-.7-1.28.23-1.81l5.92-3.42a3.48 3.48 0 013.15-.13z" />
            </g>
          </g>
          <motion.g id="contactcard__background1"
          
          animate={{x:[-15,0,-15],y:[18,0,18]}}
            transition={{duration:5,loop:Infinity,}}
          
          >
            <path
              d="M674 243.68v201.59c0 6.84-4.81 9.62-10.74 6.19L390.88 294.22c-5.93-3.42-10.73-11.74-10.73-18.59V74z"
              fill="#c1272d"
            />
          </motion.g>
          <g>
            <path
              d="M651.06 266v201.55c0 6.84-4.81 9.62-10.74 6.2L368 316.5c-5.93-3.42-10.73-11.74-10.73-18.59V96.33z"
              fill="url(#contactcard__New_Gradient_Swatch_copy_29)"
            />
            <path
              d="M357.24 56.29v40L651.06 266v-40c0-6.84-4.81-15.16-10.74-18.59L368 50.09c-6-3.42-10.76-.65-10.76 6.2zM623 210.59c0-2.83 2-4 4.43-2.56a9.79 9.79 0 014.44 7.68c0 2.82-2 4-4.44 2.55a9.81 9.81 0 01-4.43-7.67zm-12.28-7.09c0-2.83 2-4 4.44-2.56a9.81 9.81 0 014.43 7.68c0 2.82-2 4-4.43 2.56a9.81 9.81 0 01-4.49-7.68zm-26.75-15.45c0-2.82 2-4 4.43-2.56a9.8 9.8 0 014.43 7.68c0 2.83-2 4-4.43 2.56a9.78 9.78 0 01-4.48-7.68zM571.64 181c0-2.82 2-4 4.43-2.56a9.81 9.81 0 014.44 7.68c0 2.83-2 4-4.44 2.56a9.81 9.81 0 01-4.43-7.68zm-26.75-15.44c0-2.83 2-4 4.43-2.56a9.78 9.78 0 014.43 7.68c0 2.82-2 4-4.43 2.55a9.78 9.78 0 01-4.43-7.71zm-12.28-7.09c0-2.83 2-4 4.43-2.56a9.78 9.78 0 014.43 7.68c0 2.82-2 4-4.43 2.55a9.78 9.78 0 01-4.43-7.71zM505.85 143c0-2.82 2-4 4.44-2.56a9.83 9.83 0 014.43 7.68c0 2.83-2 4-4.43 2.56a9.79 9.79 0 01-4.44-7.68zm-12.27-7.09c0-2.82 2-4 4.43-2.56a9.8 9.8 0 014.43 7.68c0 2.83-2 4-4.43 2.56a9.78 9.78 0 01-4.43-7.7zm-26.76-15.44c0-2.83 2-4 4.43-2.56a9.79 9.79 0 014.44 7.67c0 2.83-2 4-4.44 2.56a9.81 9.81 0 01-4.43-7.69zm-12.28-7.09c0-2.83 2-4 4.44-2.56a9.81 9.81 0 014.43 7.68c0 2.82-2 4-4.43 2.55a9.79 9.79 0 01-4.44-7.69zm-26.75-15.47c0-2.83 2-4 4.43-2.56a9.8 9.8 0 014.43 7.68c0 2.83-2 4-4.43 2.56a9.8 9.8 0 01-4.43-7.68zm-12.28-7.09c0-2.82 2-4 4.43-2.56a9.81 9.81 0 014.44 7.68c0 2.83-2 4-4.44 2.56a9.81 9.81 0 01-4.43-7.68zm-26.75-15.44c0-2.83 2-4 4.43-2.56a9.78 9.78 0 014.43 7.67c0 2.83-2 4-4.43 2.56a9.78 9.78 0 01-4.43-7.67zm-12.28-7.09c0-2.83 2-4 4.43-2.56a9.78 9.78 0 014.43 7.67c0 2.83-2 4-4.43 2.56a9.78 9.78 0 01-4.43-7.67z"
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-2)"
            />
            <path
              d="M401.9 108.48l204.5 118.07c1.62.93 2.94-.06 2.94-2.22a7.05 7.05 0 00-2.94-5.62L401.9 100.64c-1.63-.94-2.94.06-2.94 2.22a7 7 0 002.94 5.62z"
              fill="#e83b1f"
            />
            <path
              fill="#5793ce"
              d="M397.73 177.71l20.92 12.08v-17.71L397.73 160v17.71zM429.72 196.18l20.92 12.08v-17.71l-20.92-12.08v17.71zM397.73 206.63l20.92 12.08V201l-20.92-12.08v17.71zM429.72 225.1l20.92 12.08v-17.71l-20.92-12.08v17.71z"
            />
            <path
              fill="#e2e2e2"
              d="M461.7 243.56l20.92 12.08v-17.71l-20.92-12.08v17.71zM493.69 262.03l20.92 12.08V256.4l-20.92-12.08v17.71zM525.67 280.5l20.92 12.08v-17.71l-20.92-12.08v17.71zM557.66 298.96l20.92 12.08v-17.71l-20.92-12.08v17.71zM589.64 317.43l20.92 12.08V311.8l-20.92-12.08v17.71z"
            />
            <path
              fill="#5793ce"
              d="M397.73 235.55l20.92 12.08v-17.71l-20.92-12.08v17.71zM429.72 254.02l20.92 12.08v-17.72l-20.92-12.07v17.71z"
            />
            <path
              fill="#e2e2e2"
              d="M461.7 272.48l20.92 12.08v-17.71l-20.92-12.08v17.71zM493.69 290.95l20.92 12.08v-17.71l-20.92-12.08v17.71zM525.67 309.42l20.92 12.08v-17.72l-20.92-12.07v17.71zM557.66 327.88l20.92 12.08v-17.71l-20.92-12.08v17.71zM589.64 346.35l20.92 12.08v-17.71l-20.92-12.08v17.71z"
            />
            <path
              fill="#5793ce"
              d="M397.73 264.47l20.92 12.08v-17.71l-20.92-12.08v17.71zM429.72 282.94l20.92 12.07V277.3l-20.92-12.08v17.72z"
            />
            <path
              fill="#e2e2e2"
              d="M461.7 301.4l20.92 12.08v-17.71l-20.92-12.08v17.71zM493.69 319.87l20.92 12.08v-17.71l-20.92-12.08v17.71zM525.67 338.34l20.92 12.08V332.7l-20.92-12.08v17.72zM557.66 356.8l20.92 12.08v-17.71l-20.92-12.08v17.71zM589.64 375.27l20.92 12.08v-17.71l-20.92-12.08v17.71z"
            />
            <path
              fill="#5793ce"
              d="M397.73 293.39l20.92 12.08v-17.72l-20.92-12.07v17.71zM429.72 311.86l20.92 12.07v-17.71l-20.92-12.08v17.72z"
            />
            <path
              fill="#e2e2e2"
              d="M461.7 330.32l20.92 12.08v-17.71l-20.92-12.08v17.71zM493.69 348.79l20.92 12.08v-17.72l-20.92-12.07v17.71zM525.67 367.25l20.92 12.08v-17.71l-20.92-12.08v17.71zM557.66 385.72l20.92 12.08v-17.71l-20.92-12.08v17.71zM589.64 404.19l20.92 12.08v-17.71l-20.92-12.08v17.71zM644.87 476.32l3.06-1.83-3.17-.65.11 2.48z"
            />
            <path
              d="M648 267.77v201.59c0 6.85-4.8 9.62-10.73 6.2L365 318.32c-5.93-3.43-10.73-11.75-10.73-18.59V98.14z"
              fill="#333"
            />
            <path
              d="M622.53 209.24a3.88 3.88 0 00-.48 2 9.83 9.83 0 004.44 7.7 4.14 4.14 0 001.84.59c-.73 1.27-2.22 1.57-4 .57a9.83 9.83 0 01-4.44-7.7c.03-2.08 1.11-3.24 2.64-3.16z"
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-3)"
            />
            <path
              d="M610.26 202.15a3.88 3.88 0 00-.48 2 9.83 9.83 0 004.44 7.7 4.27 4.27 0 001.84.59c-.73 1.26-2.22 1.57-4 .57a9.85 9.85 0 01-4.44-7.7c.03-2.08 1.1-3.24 2.64-3.16z"
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-4)"
            />
            <path
              d="M583.5 186.7a3.88 3.88 0 00-.48 2 9.83 9.83 0 004.44 7.7 4.11 4.11 0 001.83.59c-.72 1.26-2.22 1.57-4 .57a9.85 9.85 0 01-4.44-7.7c.04-2.08 1.15-3.24 2.65-3.16z"
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-5)"
            />
            <path
              d="M571.23 179.61a3.88 3.88 0 00-.48 2 9.85 9.85 0 004.44 7.7 4.24 4.24 0 001.83.59c-.72 1.26-2.22 1.57-4 .56a9.81 9.81 0 01-4.44-7.69c.04-2.09 1.11-3.24 2.65-3.16z"
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-6)"
            />
            <path
              d="M544.47 164.16a3.88 3.88 0 00-.48 2 9.85 9.85 0 004.44 7.7 4.2 4.2 0 001.83.59c-.73 1.26-2.22 1.57-4 .57a9.82 9.82 0 01-4.44-7.7c.04-2.09 1.11-3.24 2.65-3.16z"
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-7)"
            />
            <path
              d="M532.2 157.06a3.94 3.94 0 00-.48 2 9.81 9.81 0 004.44 7.69 4 4 0 001.83.59c-.72 1.27-2.22 1.58-4 .57a9.81 9.81 0 01-4.44-7.69c.04-2.08 1.11-3.22 2.65-3.16z"
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-8)"
            />
            <path
              d="M505.43 141.62a4 4 0 00-.48 2 9.83 9.83 0 004.45 7.7 4.2 4.2 0 001.83.59c-.73 1.26-2.22 1.57-4 .56a9.8 9.8 0 01-4.45-7.69c.04-2.09 1.12-3.24 2.65-3.16z"
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-9)"
            />
            <path
              d="M493.16 134.52a4 4 0 00-.47 2 9.79 9.79 0 004.44 7.69 4.07 4.07 0 001.83.59c-.73 1.27-2.22 1.58-4 .57a9.8 9.8 0 01-4.45-7.69c.04-2.08 1.12-3.24 2.65-3.16z"
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-10)"
            />
            <path
              d="M466.4 119.07a3.94 3.94 0 00-.48 2 9.81 9.81 0 004.44 7.69 4 4 0 001.84.59c-.73 1.27-2.22 1.58-4 .57a9.81 9.81 0 01-4.44-7.69c.03-2.08 1.1-3.23 2.64-3.16z"
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-11)"
            />
            <path
              d="M454.13 112a4 4 0 00-.48 2 9.8 9.8 0 004.45 7.69 4.07 4.07 0 001.83.59c-.73 1.27-2.22 1.58-4 .57a9.81 9.81 0 01-4.44-7.69c.03-2.1 1.11-3.26 2.64-3.16z"
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-12)"
            />
            <path
              d="M427.37 96.53a3.94 3.94 0 00-.48 2 9.81 9.81 0 004.44 7.69 4.11 4.11 0 001.83.59c-.72 1.27-2.22 1.58-4 .57a9.81 9.81 0 01-4.44-7.69c.04-2.08 1.11-3.24 2.65-3.16z"
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-13)"
            />
            <path
              d="M415.1 89.44a3.94 3.94 0 00-.48 2 9.81 9.81 0 004.44 7.69 4.14 4.14 0 001.84.59c-.73 1.27-2.23 1.58-4 .57a9.83 9.83 0 01-4.44-7.69c.03-2.08 1.1-3.24 2.64-3.16z"
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-14)"
            />
            <path
              d="M388.34 74a3.94 3.94 0 00-.48 2 9.81 9.81 0 004.44 7.69 4.11 4.11 0 001.83.59c-.73 1.27-2.22 1.58-4 .57a9.81 9.81 0 01-4.44-7.69c.04-2.09 1.11-3.25 2.65-3.16z"
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-15)"
            />
            <path
              d="M376.07 66.9a3.94 3.94 0 00-.48 2 9.83 9.83 0 004.41 7.69 4.11 4.11 0 001.83.59c-.72 1.27-2.22 1.58-4 .57a9.83 9.83 0 01-4.44-7.69c.07-2.06 1.14-3.24 2.68-3.16z"
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-16)"
            />
            <path
              d="M354.22 58.1v40L648 267.77v-40c0-6.84-4.8-15.16-10.73-18.59L365 51.9c-6-3.42-10.78-.65-10.78 6.2zm265.71 154.3c0-2.83 2-4 4.43-2.56a9.78 9.78 0 014.43 7.68c0 2.82-2 4-4.43 2.56a9.8 9.8 0 01-4.43-7.68zm-12.28-7.09c0-2.83 2-4 4.43-2.56a9.79 9.79 0 014.44 7.68c0 2.82-2 4-4.44 2.56a9.83 9.83 0 01-4.43-7.68zm-26.75-15.45c0-2.82 2-4 4.43-2.56a9.8 9.8 0 014.43 7.68c0 2.83-2 4-4.43 2.56a9.78 9.78 0 01-4.43-7.68zm-12.28-7.09c0-2.82 2-4 4.43-2.55a9.78 9.78 0 014.43 7.67c0 2.83-2 4-4.43 2.56a9.78 9.78 0 01-4.43-7.68zm-26.76-15.44c0-2.83 2-4 4.44-2.56a9.78 9.78 0 014.43 7.68c0 2.82-2 4-4.43 2.56a9.83 9.83 0 01-4.44-7.68zm-12.27-7.09c0-2.83 2-4 4.43-2.56a9.78 9.78 0 014.43 7.68c0 2.82-2 4-4.43 2.56a9.8 9.8 0 01-4.43-7.68zm-26.76-15.45c0-2.82 2-4 4.43-2.56a9.81 9.81 0 014.44 7.68c0 2.83-2 4-4.44 2.56a9.81 9.81 0 01-4.43-7.68zm-12.28-7.09c0-2.82 2-4 4.44-2.56a9.84 9.84 0 014.43 7.68c0 2.83-2 4-4.43 2.56a9.79 9.79 0 01-4.44-7.68zm-26.75-15.44c0-2.83 2-4 4.43-2.56a9.78 9.78 0 014.43 7.68c0 2.82-2 4-4.43 2.55a9.78 9.78 0 01-4.43-7.67zm-12.28-7.09c0-2.83 2-4 4.43-2.56a9.79 9.79 0 014.44 7.68c0 2.82-2 4-4.44 2.56a9.83 9.83 0 01-4.43-7.68zm-26.75-15.45c0-2.82 2-4 4.43-2.56a9.8 9.8 0 014.43 7.68c0 2.83-2 4-4.43 2.56a9.78 9.78 0 01-4.43-7.68zm-12.28-7.09c0-2.82 2-4 4.43-2.56a9.8 9.8 0 014.43 7.68c0 2.83-2 4-4.43 2.56a9.78 9.78 0 01-4.43-7.68zm-26.75-15.44c0-2.83 2-4 4.43-2.56a9.78 9.78 0 014.43 7.67c0 2.83-2 4-4.43 2.56a9.78 9.78 0 01-4.43-7.67zm-12.28-7.09c0-2.83 2-4 4.43-2.56a9.78 9.78 0 014.43 7.68c0 2.82-2 4-4.43 2.55a9.78 9.78 0 01-4.43-7.67z"
              fill="#1a1a1a"
            />
            <path
              d="M398.87 110.29l204.51 118.07c1.62.93 2.94-.06 2.94-2.22a7.05 7.05 0 00-2.94-5.62L398.87 102.45c-1.62-.93-2.93.06-2.93 2.22a7 7 0 002.93 5.62z"
              fill="#b3b3b3"
            />
            <g>
              <path
                fill="gray"
                d="M394.71 179.52l20.92 12.08v-17.71l-20.92-12.08v17.71zM426.69 197.99l20.93 12.08v-17.71l-20.93-12.08v17.71zM394.71 208.44l20.92 12.08v-17.71l-20.92-12.08v17.71zM426.69 226.91l20.93 12.08v-17.71l-20.93-12.08v17.71z"
              />
              <path
                fill="#fff"
                d="M458.68 245.38l20.92 12.07v-17.71l-20.92-12.08v17.72zM490.67 263.84l20.92 12.08v-17.71l-20.92-12.08v17.71zM522.65 282.31l20.92 12.08v-17.71l-20.92-12.08v17.71zM554.63 300.78l20.93 12.08v-17.72l-20.93-12.08v17.72zM586.62 319.24l20.92 12.08v-17.71l-20.92-12.08v17.71z"
              />
              <path
                fill="gray"
                d="M394.71 237.36l20.92 12.08v-17.71l-20.92-12.08v17.71zM426.69 255.83l20.93 12.08v-17.72l-20.93-12.07v17.71z"
              />
              <path
                fill="#fff"
                d="M458.68 274.3l20.92 12.07v-17.71l-20.92-12.08v17.72zM490.67 292.76l20.92 12.08v-17.71l-20.92-12.08v17.71zM522.65 311.23l20.92 12.08V305.6l-20.92-12.08v17.71zM554.63 329.69l20.93 12.08v-17.71l-20.93-12.08v17.71zM586.62 348.16l20.92 12.08v-17.71l-20.92-12.08v17.71z"
              />
              <path
                fill="gray"
                d="M394.71 266.28l20.92 12.08v-17.71l-20.92-12.08v17.71zM426.69 284.75l20.93 12.08v-17.72l-20.93-12.07v17.71z"
              />
              <path
                fill="#fff"
                d="M458.68 303.21l20.92 12.08v-17.71l-20.92-12.08v17.71zM490.67 321.68l20.92 12.08v-17.71l-20.92-12.08v17.71zM522.65 340.15l20.92 12.08v-17.72l-20.92-12.07v17.71zM554.63 358.61l20.93 12.08v-17.71l-20.93-12.08v17.71zM586.62 377.08l20.92 12.08v-17.71l-20.92-12.08v17.71z"
              />
              <path
                fill="gray"
                d="M394.71 295.2l20.92 12.08v-17.71l-20.92-12.08v17.71zM426.69 313.67l20.93 12.08v-17.72l-20.93-12.08v17.72z"
              />
              <path
                fill="#fff"
                d="M458.68 332.13l20.92 12.08V326.5l-20.92-12.08v17.71zM490.67 350.6l20.92 12.08v-17.71l-20.92-12.08v17.71zM522.65 369.07l20.92 12.07v-17.71l-20.92-12.07v17.71zM554.63 387.53l20.93 12.08V381.9l-20.93-12.08v17.71zM586.62 406l20.92 12.08v-17.71l-20.92-12.08V406z"
              />
            </g>
            <g>
              <path
                d="M604.24 197.92c0 9.76 6.85 13.72 15.3 8.84s15.3-16.75 15.3-26.51-6.85-13.71-15.3-8.83-15.3 16.74-15.3 26.5zm3.26-1.92c0-7.68 5.39-17 12-20.86s12-.72 12 7-5.39 17-12 20.85-12 .72-12-6.99z"
                fill="#c1272d"
              />
              <path
                fill="#d4ecff"
                d="M610.18 208.95l-1.69-1.26 1.44.34.25.92zM630.92 170.71l2.34 1.71-1.92.57-.42-2.28z"
              />
              <path
                d="M606.34 199.46c0 9.76 6.85 13.72 15.3 8.84S637 191.55 637 181.79s-6.85-13.71-15.31-8.83-15.35 16.74-15.35 26.5zm3.27-1.88c0-7.68 5.39-17 12-20.85s12-.73 12 7-5.39 17-12 20.85-12 .68-12-7z"
                fill="url(#contactcard__New_Gradient_Swatch_copy_29-17)"
              />
            </g>
            <path
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-18)"
              d="M622.24 200.72l2.28-2.52 6.57 3.8-4.21 2.15-4.64-3.43z"
            />
            <path
              d="M622.16 200.4l5.94 3.43-4.08 4-7.57 3.38s.54-3.31-2.59-7.05z"
              fill="#cd5257"
            />
            <g>
              <path
                d="M565.18 175.37c0 9.76 6.85 13.72 15.31 8.84s15.3-16.75 15.3-26.51-6.85-13.71-15.3-8.83-15.31 16.74-15.31 26.5zm3.27-1.88c0-7.68 5.39-17 12-20.85s12-.73 12 7-5.39 17-12 20.85-12 .68-12-7z"
                fill="#c1272d"
              />
              <path
                fill="#d4ecff"
                d="M571.13 186.4l-1.7-1.26 1.45.35.25.91zM591.87 148.16l2.34 1.71-1.92.57-.42-2.28z"
              />
              <path
                d="M567.29 176.91c0 9.76 6.85 13.72 15.3 8.84s15.3-16.75 15.3-26.51-6.85-13.71-15.3-8.83-15.3 16.74-15.3 26.5zm3.26-1.88c0-7.68 5.39-17 12-20.85s12-.73 12 6.95-5.39 17-12 20.85-12 .73-12-6.98z"
                fill="url(#contactcard__New_Gradient_Swatch_copy_29-19)"
              />
            </g>
            <path
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-20)"
              d="M583.19 178.17l2.28-2.51 6.56 3.79-4.2 2.15-4.64-3.43z"
            />
            <path
              d="M583.11 177.85l5.93 3.43-4.07 4-7.57 3.38s.54-3.31-2.59-7z"
              fill="#cd5257"
            />
            <g>
              <path
                d="M577.47 182.48c0 9.75 6.86 13.71 15.31 8.83s15.3-16.75 15.3-26.5-6.85-13.72-15.3-8.84-15.31 16.75-15.31 26.51zm3.27-1.89c0-7.68 5.39-17 12-20.85s12-.73 12 6.95-5.39 17-12 20.85-12 .73-12-6.95z"
                fill="#c1272d"
              />
              <path
                fill="#d4ecff"
                d="M583.42 193.5l-1.69-1.26 1.44.35.25.91zM604.16 155.26l2.34 1.72-1.92.56-.42-2.28z"
              />
              <path
                d="M579.58 184c0 9.76 6.85 13.71 15.3 8.83s15.31-16.74 15.31-26.5-6.85-13.72-15.31-8.84-15.3 16.77-15.3 26.51zm3.26-1.89c0-7.67 5.39-17 12-20.85s12-.73 12 6.95-5.39 17-12 20.85-12 .75-12-6.93z"
                fill="url(#contactcard__New_Gradient_Swatch_copy_29-21)"
              />
            </g>
            <path
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-22)"
              d="M595.48 185.28l2.28-2.52 6.57 3.8-4.21 2.14-4.64-3.42z"
            />
            <path
              d="M595.4 185l5.94 3.43-4.08 4-7.57 3.39s.54-3.32-2.59-7.05z"
              fill="#cd5257"
            />
            <g>
              <path
                d="M526.12 152.76c0 9.76 6.85 13.72 15.31 8.84s15.3-16.75 15.3-26.51-6.85-13.71-15.3-8.83-15.31 16.74-15.31 26.5zm3.27-1.88c0-7.68 5.39-17 12-20.85s12-.73 12 6.95-5.39 17-12 20.85-12 .73-12-6.95z"
                fill="#c1272d"
              />
              <path
                fill="#d4ecff"
                d="M532.07 163.79l-1.7-1.26 1.45.35.25.91zM552.81 125.55l2.34 1.71-1.92.57-.42-2.28z"
              />
              <path
                d="M528.23 154.3c0 9.76 6.85 13.72 15.3 8.84s15.3-16.75 15.3-26.51-6.85-13.71-15.3-8.83-15.3 16.74-15.3 26.5zm3.26-1.88c0-7.68 5.39-17 12-20.85s12-.73 12 7-5.39 17-12 20.85-12 .68-12-7z"
                fill="url(#contactcard__New_Gradient_Swatch_copy_29-23)"
              />
            </g>
            <path
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-24)"
              d="M544.13 155.56l2.21-2.49 6.58 3.8-4.15 2.12-4.64-3.43z"
            />
            <path
              d="M544 155.31l6 3.4-4 4-7.5 3.35s.47-3.28-2.66-7z"
              fill="#cd5257"
            />
            <g>
              <path
                d="M538.41 159.87c0 9.75 6.86 13.71 15.31 8.83S569 152 569 142.2s-6.85-13.72-15.3-8.84-15.29 16.75-15.29 26.51zm3.27-1.89c0-7.68 5.39-17 12-20.85s12-.73 12 7-5.39 17-12 20.85-12 .68-12-6.98z"
                fill="#c1272d"
              />
              <path
                fill="#d4ecff"
                d="M544.36 170.9l-1.7-1.27 1.45.35.25.92zM565.1 132.65l2.34 1.72-1.92.56-.42-2.28z"
              />
              <path
                d="M540.52 161.41c0 9.76 6.85 13.71 15.3 8.83s15.31-16.74 15.31-26.5-6.85-13.72-15.31-8.84-15.3 16.75-15.3 26.51zm3.26-1.89c0-7.67 5.39-17 12-20.85s12-.73 12 7-5.39 17-12 20.85-12 .68-12-7z"
                fill="url(#contactcard__New_Gradient_Swatch_copy_29-25)"
              />
            </g>
            <path
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-26)"
              d="M556.42 162.66l2.28-2.51 6.57 3.8-4.21 2.14-4.64-3.43z"
            />
            <path
              d="M556.34 162.34l5.94 3.43-4.08 4-7.52 3.36s.49-3.25-2.64-7z"
              fill="#cd5257"
            />
            <g>
              <path
                d="M487.06 130.15c0 9.76 6.85 13.72 15.31 8.84s15.3-16.75 15.3-26.51-6.85-13.71-15.3-8.83-15.31 16.74-15.31 26.5zm3.27-1.88c0-7.68 5.39-17 12-20.85s12-.73 12 7-5.39 17-12 20.85-12 .73-12-7z"
                fill="#c1272d"
              />
              <path
                fill="#d4ecff"
                d="M493.01 141.18l-1.7-1.26 1.45.34.25.92zM513.75 102.94l2.34 1.71-1.92.57-.42-2.28z"
              />
              <path
                d="M489.17 131.69c0 9.76 6.85 13.72 15.3 8.84s15.3-16.75 15.3-26.51-6.85-13.71-15.3-8.83-15.3 16.75-15.3 26.5zm3.26-1.88c0-7.68 5.39-17 12-20.85s12-.73 12 7-5.39 17-12 20.85-12 .68-12-7z"
                fill="url(#contactcard__New_Gradient_Swatch_copy_29-27)"
              />
            </g>
            <path
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-28)"
              d="M505.07 132.95l2.2-2.43 6.54 3.77-4.1 2.09-4.64-3.43z"
            />
            <path
              d="M504.87 132.68l6 3.48-4 3.94-7.46 3.33s.39-3.22-2.74-7z"
              fill="#cd5257"
            />
            <g>
              <path
                d="M499.35 137.26c0 9.75 6.86 13.71 15.31 8.83s15.3-16.75 15.3-26.5-6.85-13.72-15.3-8.84-15.31 16.75-15.31 26.51zm3.27-1.89c0-7.68 5.39-17 12-20.85s12-.73 12 7-5.39 17-12 20.85-12 .68-12-7z"
                fill="#c1272d"
              />
              <path
                fill="#d4ecff"
                d="M505.3 148.28l-1.69-1.26 1.44.35.25.91zM526.04 110.04l2.34 1.72-1.92.56-.42-2.28z"
              />
              <path
                d="M501.46 138.8c0 9.76 6.85 13.71 15.3 8.83s15.31-16.74 15.31-26.5-6.86-13.72-15.31-8.84-15.3 16.71-15.3 26.51zm3.26-1.89c0-7.67 5.39-17 12-20.85s12-.73 12 7-5.39 17-12 20.85-12 .68-12-7z"
                fill="url(#contactcard__New_Gradient_Swatch_copy_29-29)"
              />
            </g>
            <path
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-30)"
              d="M517.36 140.06l2.21-2.44 6.55 3.76-4.12 2.1-4.64-3.42z"
            />
            <path
              d="M517.17 139.78l6 3.46-4 4-7.48 3.39s.41-3.28-2.72-7z"
              fill="#cd5257"
            />
            <g>
              <path
                d="M448 107.54c0 9.76 6.85 13.72 15.31 8.84s15.3-16.75 15.3-26.51-6.85-13.71-15.3-8.83S448 97.78 448 107.54zm3.27-1.88c0-7.68 5.39-17 12-20.85s12-.73 12 7-5.39 17-12 20.85-12 .68-12-7z"
                fill="#c1272d"
              />
              <path
                fill="#d4ecff"
                d="M453.95 118.57l-1.7-1.26 1.45.35.25.91zM474.69 80.33l2.34 1.71-1.92.57-.42-2.28z"
              />
              <path
                d="M450.11 109.08c0 9.76 6.85 13.72 15.3 8.84s15.3-16.75 15.3-26.51-6.85-13.71-15.3-8.83-15.3 16.75-15.3 26.5zm3.26-1.88c0-7.68 5.39-17 12-20.85s12-.73 12 7-5.39 17-12 20.85-12 .68-12-7z"
                fill="url(#contactcard__New_Gradient_Swatch_copy_29-31)"
              />
            </g>
            <path
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-32)"
              d="M466.01 110.34l2.17-2.39 6.51 3.76-4.04 2.06-4.64-3.43z"
            />
            <path
              d="M465.75 110.1l6.05 3.49-4 3.9-7.43 3.32s.35-3.17-2.77-6.9z"
              fill="#cd5257"
            />
            <g>
              <path
                d="M460.29 114.65c0 9.76 6.86 13.71 15.31 8.83s15.3-16.75 15.3-26.5-6.85-13.72-15.3-8.84-15.31 16.75-15.31 26.51zm3.27-1.89c0-7.68 5.39-17 12-20.85s12-.73 12 7-5.39 17-12 20.85-12 .68-12-7z"
                fill="#c1272d"
              />
              <path
                fill="#d4ecff"
                d="M466.24 125.67l-1.7-1.26 1.45.35.25.91zM486.98 87.43l2.34 1.72-1.92.56-.42-2.28z"
              />
              <path
                d="M462.4 116.19c0 9.76 6.85 13.71 15.3 8.83s15.3-16.74 15.3-26.5-6.86-13.72-15.31-8.84-15.29 16.75-15.29 26.51zm3.26-1.89c0-7.67 5.39-17 12-20.85s12-.73 12 7-5.39 17-12 20.85-12 .7-12-7z"
                fill="url(#contactcard__New_Gradient_Swatch_copy_29-33)"
              />
            </g>
            <path
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-34)"
              d="M478.3 117.44l2.18-2.39 6.51 3.76-4.05 2.06-4.64-3.43z"
            />
            <path
              d="M478.05 117.2l6 3.48-4 3.91-7.44 3.33s.33-3.21-2.8-7z"
              fill="#cd5257"
            />
            <g>
              <path
                d="M408.94 84.93c0 9.76 6.85 13.72 15.31 8.84s15.3-16.75 15.3-26.51-6.85-13.71-15.3-8.83-15.31 16.74-15.31 26.5zm3.27-1.88c0-7.68 5.39-17 12-20.85s12-.73 12 7-5.39 17-12 20.85-12 .68-12-7z"
                fill="#c1272d"
              />
              <path
                fill="#d4ecff"
                d="M414.89 95.96l-1.7-1.26 1.45.35.25.91zM435.63 57.72l2.34 1.71-1.92.57-.42-2.28z"
              />
              <path
                d="M411.05 86.47c0 9.76 6.85 13.72 15.3 8.84s15.3-16.75 15.3-26.51-6.85-13.71-15.3-8.8-15.3 16.72-15.3 26.47zm3.26-1.88c0-7.68 5.39-17 12-20.85s12-.73 12 6.95-5.39 17-12 20.85-12 .73-12-6.95z"
                fill="url(#contactcard__New_Gradient_Swatch_copy_29-35)"
              />
            </g>
            <path
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-36)"
              d="M426.95 87.73l2.13-2.36 6.5 3.75-3.99 2.04-4.64-3.43z"
            />
            <path
              d="M426.6 87.5l6 3.49-3.92 3.89-7.39 3.3s.36-3.25-2.85-6.87z"
              fill="#cd5257"
            />
            <g>
              <path
                d="M421.23 92c0 9.76 6.86 13.71 15.31 8.83s15.3-16.75 15.3-26.5-6.85-13.72-15.3-8.84S421.23 82.28 421.23 92zm3.27-1.89c0-7.68 5.39-17 12-20.85s12-.73 12 7-5.39 17-12 20.85-12 .72-12-6.96z"
                fill="#c1272d"
              />
              <path
                fill="#d4ecff"
                d="M427.18 103.06l-1.7-1.26 1.45.35.25.91zM447.92 64.82l2.34 1.72-1.92.56-.42-2.28z"
              />
              <path
                d="M423.34 93.58c0 9.76 6.85 13.71 15.3 8.83S454 85.67 454 75.91s-6.86-13.72-15.31-8.84-15.35 16.75-15.35 26.51zm3.26-1.89c0-7.67 5.39-17 12-20.85s12-.73 12 7-5.39 17-12 20.85-12 .68-12-7z"
                fill="url(#contactcard__New_Gradient_Swatch_copy_29-37)"
              />
            </g>
            <path
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-38)"
              d="M439.24 94.83l2.14-2.36 6.5 3.75-4 2.04-4.64-3.43z"
            />
            <path
              d="M438.93 94.62l6 3.47L441 102l-7.41 3.31s.46-3.31-2.85-6.9z"
              fill="#cd5257"
            />
            <g>
              <path
                d="M369.88 62.32c0 9.76 6.85 13.72 15.31 8.84s15.3-16.75 15.3-26.51-6.85-13.71-15.3-8.83-15.31 16.74-15.31 26.5zm3.27-1.88c0-7.68 5.39-17 12-20.85s12-.73 12 6.95-5.39 17-12 20.85-12 .73-12-6.95z"
                fill="#c1272d"
              />
              <path
                fill="#d4ecff"
                d="M375.83 73.35l-1.7-1.26 1.45.35.25.91zM396.57 35.11l2.34 1.71-1.92.57-.42-2.28z"
              />
              <path
                d="M372 63.86c0 9.76 6.85 13.72 15.3 8.84s15.3-16.75 15.3-26.51-6.85-13.71-15.3-8.83S372 54.11 372 63.86zm3.25-1.86c0-7.68 5.39-17 12-20.85s12-.73 12 6.95-5.39 17-12 20.85-12 .71-12-6.95z"
                fill="url(#contactcard__New_Gradient_Swatch_copy_29-39)"
              />
            </g>
            <path
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-40)"
              d="M387.89 65.12l2.1-2.32 6.47 3.74-3.94 2.01-4.63-3.43z"
            />
            <path
              d="M387.54 65l6 3.47-3.89 3.85-7.36 3.29s.32-3.35-2.94-6.88z"
              fill="#cd5257"
            />
            <g>
              <path
                d="M382.17 69.43c0 9.76 6.86 13.71 15.31 8.83s15.3-16.75 15.3-26.5-6.85-13.72-15.3-8.84-15.31 16.75-15.31 26.51zm3.27-1.89c0-7.68 5.39-17 12-20.85s12-.73 12 7-5.39 17-12 20.85-12 .68-12-7z"
                fill="#c1272d"
              />
              <path
                fill="#d4ecff"
                d="M388.12 80.45l-1.7-1.26 1.45.35.25.91zM408.86 42.21l2.34 1.72-1.92.56-.42-2.28z"
              />
              <path
                d="M384.28 71c0 9.76 6.85 13.71 15.3 8.83s15.31-16.74 15.31-26.5-6.89-13.75-15.31-8.87-15.3 16.75-15.3 26.54zm3.26-1.89c0-7.67 5.39-17 12-20.85s12-.73 12 7-5.39 17-12 20.85-12 .65-12-7.03z"
                fill="url(#contactcard__New_Gradient_Swatch_copy_29-41)"
              />
            </g>
            <path
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-42)"
              d="M400.18 72.22l2.11-2.32 6.47 3.74-3.94 2.01-4.64-3.43z"
            />
            <path
              d="M399.82 72l6 3.49-3.82 3.88-7.38 3.39s.35-3.39-2.93-7z"
              fill="#cd5257"
            />
            <g>
              <path
                d="M616.52 205c0 9.76 6.85 13.71 15.3 8.83s15.3-16.74 15.3-26.5-6.85-13.72-15.3-8.84-15.3 16.77-15.3 26.51zm3.26-1.89c0-7.67 5.39-17 12-20.85s12-.73 12 6.95-5.39 17-12 20.85-12 .75-12-6.93z"
                fill="#c1272d"
              />
              <path
                fill="#d4ecff"
                d="M622.46 216.05l-1.69-1.27 1.44.35.25.92zM643.21 177.8l2.34 1.72-1.93.56-.41-2.28z"
              />
              <path
                d="M618.62 206.56c0 9.76 6.85 13.71 15.3 8.83s15.31-16.74 15.31-26.5-6.85-13.72-15.31-8.84-15.3 16.75-15.3 26.51zm3.27-1.89c0-7.67 5.39-17 12-20.85s12-.72 12 7-5.39 17-12 20.85-12 .68-12-7z"
                fill="url(#contactcard__New_Gradient_Swatch_copy_29-43)"
              />
            </g>
            <path
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-44)"
              d="M648.03 267.77l3.03-1.81v-5.24l-3.03 1.94v5.11z"
            />
            <path
              d="M634.52 207.82l2.28-2.52s4.75 2.51 6.34 4.09l-4 1.85z"
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-45)"
            />
            <path
              d="M634.44 207.49s5 2.55 7.28 5.3-13 5.56-13 5.56.54-3.31-2.59-7z"
              fill="#cd5257"
            />
          </g>
          <g>
            <path
              d="M148.76 347.64a39.84 39.84 0 00-4.92-2.35l-9.45-4.19.71 1.65a61 61 0 00-22.18-.24l.45-1.83-11.13 4.93h.07a40.1 40.1 0 00-4.16 2c-14 8.06-14 21.13 0 29.19s36.6 8.06 50.56 0 14.01-21.1.05-29.16z"
              fill="#ccc"
            />
            <path
              d="M135.32 355.25c-6.54 3.78-17.15 3.78-23.69 0s-6.54-9.9 0-13.67 17.15-3.78 23.69 0 6.55 9.9 0 13.67z"
              fill="#c1272d"
            />
            <path
              d="M123.48 351a5.7 5.7 0 01-5.7-5.69v-72h11.39v72a5.69 5.69 0 01-5.69 5.69z"
              fill="red"
            />
            <path
              d="M127.48 276a9.09 9.09 0 01-8.22 0c-2.27-1.31-2.27-3.44 0-4.75a9.09 9.09 0 018.22 0c2.27 1.26 2.27 3.39 0 4.75z"
              fill="#c1272d"
            />
            <path
              d="M123.48 275.81a4.62 4.62 0 01-4.62-4.62v-67.67h9.23v67.67a4.61 4.61 0 01-4.61 4.62z"
              fill="#ccc"
            />
            <g>
              <path
                d="M189.86 239v-2.65l3.74-.54 4.19-3.14a2.82 2.82 0 012.76-.1l3.1 1.78 3.06-.44v2.69a1 1 0 01-.7.81l-9.77 4.35a3.06 3.06 0 01-2.55-.1l-3.25-1.88a.92.92 0 01-.55-.78z"
                fill="#791414"
              />
              <path
                d="M190.26 235.62l7.53-5.64a2.79 2.79 0 012.76-.1l5.62 3.24c.79.46.71 1.2-.17 1.6l-9.77 4.34a3 3 0 01-2.55-.09l-3.25-1.88c-.69-.4-.76-1.03-.17-1.47z"
                fill="red"
              />
              <path
                d="M177.56 248.4a6.18 6.18 0 003-.74l11.7-6.76a1.35 1.35 0 10-1.35-2.34l-11.7 6.76a3.88 3.88 0 01-3.33 0l-19.45-11.27a1.35 1.35 0 00-1.35 2.34l19.45 11.27a6.2 6.2 0 003.03.74z"
                fill="#ccc"
              />
            </g>
            <g>
              <path
                fill="url(#contactcard__\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_242)"
                d="M65.03 223.64l18.79-10.92-10.53-4.76-9 6.39.74 9.29z"
              />
              <path
                d="M185.71 207.43a25.88 25.88 0 01-3.17-2l-40-29.35c-7.23-5.3-14.67-6.66-20.43-3.74-.15.07-.28.18-.42.26h-.05L66.3 204.7l5 1.66 19.37 8.78L117 233.83l20.8 11 .94.2c4.83-4.03 10.26-7.55 13.26-13.51 5.15-9 19.48-11.58 27.91-18.89.85.54 1.7 1.05 2.55 1.49 1.72-1.71 2.19-4.12 3.25-6.69z"
                fill="#1a1a1a"
              />
              <path
                d="M203.27 194.19a3.74 3.74 0 00-2.27.81l-54.13 31.3 2 8.09 2-1c-3.1 4.83-7.85 8-12.16 11.64l6.12 1.29 53-30.84a6.88 6.88 0 00.74-.32 13.5 13.5 0 002-1.29l.09-.06c4-3.12 6.31-8.54 6.31-15.31v-.64a3.72 3.72 0 00-3.7-3.67z"
                fill="#333"
              />
              <path
                d="M129.16 170.87a22.53 22.53 0 0110.62 3.44 22.53 22.53 0 00-10.62-3.44z"
                fill="#eaeaea"
              />
              <path d="M153.8 228.82v-.63a3.72 3.72 0 10-7.43 0v.63c0 5-1.59 8.63-4.34 10-3.12 1.57-7.85.41-12.67-3.12l-40.05-29.31c-6.16-4.52-12.47-6.15-17.76-4.73l33.07-19.19L66.3 204.7l5 1.66 19.37 8.78L117 233.83l20.8 11 .94.2c4.83-4.03 10.26-7.55 13.26-13.51a15.66 15.66 0 011.81-2.49c-.02-.03-.01-.14-.01-.21z" />
              <path
                d="M137.76 248.19c-4.38 0-9.21-1.79-13.94-5.26l-40-29.34c-4.82-3.53-9.55-4.69-12.67-3.11-2.76 1.39-4.34 5.05-4.34 10a3.72 3.72 0 01-7.44 0c0-7.88 3.07-13.95 8.41-16.66 5.75-2.91 13.2-1.55 20.43 3.75l40.05 29.35c4.81 3.52 9.55 4.68 12.67 3.11 2.75-1.4 4.33-5.05 4.33-10v-.64a3.72 3.72 0 017.44 0v.61c0 7.87-3.06 13.94-8.41 16.65a14.21 14.21 0 01-6.53 1.54z"
                fill="#ccc"
              />
            </g>
            <motion.g id="contactcard__person"
            
            animate={{y:[20,0,20]}}
            transition={{duration:5,loop:Infinity}}
            
            
            >
              <path
                d="M106.29 313.79s-7.54-3.8-12.18 1.86-11.25 19-11.45 28.07 7.15 8.42 11.52 6.29 17.14-20.67 17.91-24.3-.91-8.54-2.14-9.5-3.66-2.42-3.66-2.42z"
                fill="#1a1a1a"
              />
              <path
                d="M107.93 312l.35 7.82a4.41 4.41 0 01-2.21 4.06 8.69 8.69 0 01-5.81.91c-5.68-.91-6.19-2.54-6.6-10.35s14.27-2.44 14.27-2.44z"
                fill="#666"
              />
              <path
                d="M78.68 298.77s-7.54-3.81-12.17 1.86-11.26 19-11.46 28.07 7.15 8.42 11.52 6.28 17.14-20.66 17.91-24.29-.91-8.54-2.14-9.5-3.66-2.42-3.66-2.42z"
                fill="#1a1a1a"
              />
              <path
                d="M80.33 297l.34 7.81a4.42 4.42 0 01-2.2 4.07 8.66 8.66 0 01-5.82.9c-5.68-.91-6.19-2.53-6.6-10.34S80.33 297 80.33 297z"
                fill="#666"
              />
              <path
                d="M147.62 153.49c-2.23-36.32-39.33 5.35-39.33 5.35L82.9 183.73 60 208.85A22.52 22.52 0 0054.35 227l9.25 70.44a6.93 6.93 0 006.94 6 24.26 24.26 0 003.43-.3c8.25-1.29 7.64-9.14 7.64-9.14l-1.69-65.9 48-28.95s21.94-9.34 19.7-45.66z"
                fill="#333"
              />
              <path
                d="M175.23 167.33c-2.23-36.33-39.33 5.35-39.33 5.35l-25.4 24.89-22.86 25.12a22.49 22.49 0 00-5.64 18.1l9.25 70.44a6.91 6.91 0 006.94 6 21.61 21.61 0 003.43-.3c8.25-1.28 7.64-9.13 7.64-9.13l-1.69-65.87 48-28.95s21.89-9.33 19.66-45.65z"
                fill="#333"
              />
              <path
                d="M153.28 50.74C181.41 62.4 180.85 79 180.85 79s-5.51 61-3.63 101.67c.78 17-90.42 18.32-76.82-27.09 16-53.53 10-96.87 17.53-103.41s28.07-2.45 35.35.57z"
                fill="#c1272d"
              />
              <path
                d="M162.33 65.49c-1.47 5.71-9 8.72-16.71 6.72s-12.86-8.25-11.39-14 9-8.72 16.72-6.72 12.85 8.28 11.38 14z"
                fill="#ffc2b0"
              />
              <path
                d="M150.37 74.16a20.66 20.66 0 01-5.09-.65 18.7 18.7 0 01-9.86-6 10.75 10.75 0 01-2.49-9.56c1.65-6.42 9.89-9.86 18.35-7.69s14 9.18 12.35 15.6c-1.31 5.08-6.81 8.3-13.26 8.3zm-4.24-21.91c-5.22 0-9.59 2.43-10.59 6.33a8.11 8.11 0 002 7.19 16 16 0 008.46 5.14c7 1.81 13.8-.77 15.08-5.76s-3.39-10.51-10.42-12.32a17.61 17.61 0 00-4.53-.58z"
                fill="#fff"
              />
              <path
                d="M142 49.47s.25 1.13-.24 10c-.15 2.81 9.66 5.42 12.2 2.89s1.52-5.18 2.13-14.71S142 49.47 142 49.47z"
                fill="#ffc2b0"
              />
              <path
                d="M156.09 47.69s-2.42 8.84-14.33 12.23l.18-8z"
                fill="#ea9c92"
              />
              <circle
                cx={142.67}
                cy={30.64}
                r={21.65}
                transform="rotate(-59.12 142.665 30.648)"
                fill="#ffc2b0"
              />
              <path
                d="M147.64 31.44s-11.92 5.1-20.17 5.16-6.47-6.85-6.47-6.85l24.5-3.54z"
                fill="#ea9c92"
              />
              <path
                d="M125 32.78s10.38-4.41 19.49-2.57a9.58 9.58 0 015.51 3.27 3.25 3.25 0 001.66 1.21c1.62.36 4.26-6.34 7.4-6.49s5.24 2.07 2.66 6.19-1.7 8.74-.52 9.4 13.75-9 2.67-30.92-39.23-10.13-43.61-5.68c0 0-4.61 4-8.36.44 0 0-4.21 31.5 13.1 25.15z"
                fill="#c1272d"
              />
              <path
                d="M165.07 123.57V140a6.72 6.72 0 01-2.19 5L129 175.85l3.85 5.88 44.68-32.41a9.06 9.06 0 003.7-6.4l3-28.73z"
                fill="#ffc2b0"
              />
              <path
                d="M178.47 70.79s10.26 15.44 14.09 56.08c0 0-17.54 5.67-27.49 2.45s13.4-58.53 13.4-58.53z"
                fill="#c1272d"
              />
              <path
                d="M163.19 90.31s-4 21.51-4.24 31.62a6.43 6.43 0 004.24 6.23z"
                fill="#611417"
              />
              <g>
                <path
                  d="M154.41 197.26l-7.47-1-48.28-27.86a6.7 6.7 0 00-6 .26L58.41 188.4l-4.52-.6v4.5a1.76 1.76 0 001 1.59l54.71 31.59a6.73 6.73 0 006-.25l37.26-21.51a2.43 2.43 0 001.47-2z"
                  fill="#510d0d"
                />
                <path
                  d="M118.14 179.65l-3.43-2H77L58.41 188.4l-4.52-.6v4.5a1.76 1.76 0 001 1.59l54.71 31.59a5.66 5.66 0 003.12.58z"
                  fill="#510d0d"
                />
                <path
                  d="M55.9 188.07l-2-.27v4.5a1.76 1.76 0 001 1.59l1 .56z"
                  fill="#5793ce"
                />
                <path
                  d="M110.19 225.73a7 7 0 005.14-.32v-7.66h-5.14z"
                  fill="#791414"
                />
                <path
                  d="M109.64 221l-54.71-31.61c-1.55-.89-1.35-2.45.44-3.49l37.25-21.5a6.73 6.73 0 016-.25l54.71 31.59c1.55.89 1.35 2.45-.43 3.49l-37.26 21.5a6.73 6.73 0 01-6 .27z"
                  fill="#fff"
                />
                <path
                  d="M108.72 216.19l-45.49-26.27c-1.29-.74-1.13-2 .36-2.89l20-11.23a5.58 5.58 0 015-.21l45.49 26.27c1.29.74 1.13 2-.36 2.9l-20 11.22a5.58 5.58 0 01-5 .21z"
                  fill="#d9a3a3"
                />
              </g>
              <g>
                <path
                  d="M107.79 224l-4.59-6L55 190.09a6.7 6.7 0 01-2.8-5.36l.05-39.49-2.78-3.62 2.53-1.51a1.77 1.77 0 011.89.11l54.68 31.65a6.72 6.72 0 012.79 5.36v43a2.42 2.42 0 01-1 2.29z"
                  fill="#510d0d"
                />
                <path
                  d="M74.43 201.36l-3.43-2-18.81-32.66v-21.46l-2.78-3.62 2.59-1.51a1.77 1.77 0 011.89.11l54.68 31.65a5.76 5.76 0 012.06 2.41z"
                  fill="#791414"
                />
                <path
                  d="M50.66 143.22l-1.23-1.6 2.57-1.51a1.77 1.77 0 011.89.11l1 .56zM109.1 172.22a7 7 0 012.29 4.61l-5.39 3.08-2.56-4.44z"
                  fill="#a11a1a"
                />
                <path
                  d="M106 173.38l-54.67-31.65c-1.55-.9-2.8.05-2.81 2.11v43a6.71 6.71 0 002.79 5.35L106 223.87c1.54.89 2.8-.05 2.8-2.12v-43a6.73 6.73 0 00-2.8-5.37z"
                  fill="#a11a1a"
                />
              </g>
              <path
                d="M132.89 181.73l-.88 1.81a12.23 12.23 0 01-4.57 5.07L122 192a5.4 5.4 0 01-5.55.13l-.18-.11a3.27 3.27 0 01-.46-5l5.67-5.83s-3.19 2.44-4.08 1.46c-.65-.72 3.09-4.24 6-4.36a11.3 11.3 0 005.66-2.37z"
                fill="#ffc2b0"
              />
              <g>
                <path
                  d="M94.74 163.36l-.57 3.78a27.86 27.86 0 00.25 9.68l.67 3.33a4.67 4.67 0 003.75 3.67 2.57 2.57 0 003-2.25l.91-8.07s2.06 2.7 3.06 2.7-1.12-8.08-3.37-12.65-7.7-.19-7.7-.19z"
                  fill="#ffc2b0"
                />
                <path
                  d="M113.28 103.37L107.41 115a22.74 22.74 0 00-2.4 8.82l-2.55 39.74-7.72-.19-3.51-44.63a16.27 16.27 0 01.2-4.12l4-22.63z"
                  fill="#ffc2b0"
                />
                <path
                  d="M118.5 50.12s-20.81 22.63-29.2 43.4c0 0 7.11 12.82 24.53 17.85s4.67-61.25 4.67-61.25z"
                  fill="#c1272d"
                />
                <path
                  d="M109.91 110l3.37-32.57-7.94 30.57a43.93 43.93 0 004.57 2z"
                  fill="#611417"
                />
              </g>
            </motion.g>
          </g>
          <path
            d="M595.68 453.11a1.55 1.55 0 01-.8-.21L387.77 333.33a1.59 1.59 0 011.59-2.76l207.11 119.58a1.59 1.59 0 01.58 2.17 1.57 1.57 0 01-1.37.79z"
            fill="#c1272d"
          />
          <motion.g id="contactcard__boxes" 
          
          animate={{y:[0,-10,0]}}
          transition={{duration:3,loop:Infinity}}
          
          >
            <path
              fill="#ccc"
              d="M74.87 543.74l20.78 12.32-15.44 8.67-20.78-12.32 15.44-8.67z"
              id="contactcard__box18"
            />
            <path
              fill="#ccc"
              d="M126.56 577.55l20.78 12.32-15.44 8.68-20.78-12.32 15.44-8.68z"
              id="contactcard__box17"
            />
            <path
              fill="#c1272d"
              d="M172.13 606.46l20.78 12.32-15.45 8.68-20.77-12.32 15.44-8.68z"
              id="contactcard__box16"
            />
            <path
              fill="#c1272d"
              d="M297.42 292.01l20.78 12.32-15.45 8.68-20.77-12.32 15.44-8.68z"
              id="contactcard__box15"
            />
            <path
              fill="red"
              d="M286.47 130.58l20.78 12.32-15.44 8.68-20.78-12.33 15.44-8.67z"
              id="contactcard__box14"
            />
            <path
              fill="red"
              d="M15.44 217.16l20.78 12.33-15.44 8.67L0 225.84l15.44-8.68z"
              id="contactcard__box13"
            />
            <path
              fill="#c1272d"
              d="M388.08 370.65l20.78 12.32-15.44 8.67-20.78-12.32 15.44-8.67z"
              id="contactcard__box12"
            />
            <path
              fill="#ccc"
              d="M320.36 204.46l20.78 12.32-15.44 8.68-20.78-12.32 15.44-8.68z"
              id="contactcard__box11"
            />
            <path
              fill="#ccc"
              d="M159.64 288.09l20.78 12.32-15.44 8.68-20.78-12.33 15.44-8.67z"
              id="contactcard__box10"
            />
            <path
              fill="url(#contactcard__New_Gradient_Swatch_copy_29-46)"
              d="M675.9 179.45l20.78 12.32-15.44 8.68-20.78-12.33 15.44-8.67z"
              id="contactcard__box9"
            />
            <path
              fill="#ccc"
              d="M547.59 457.13l20.78 12.33-15.44 8.67-20.78-12.32 15.44-8.68z"
              id="contactcard__box8"
            />
            <path
              fill="#ccc"
              d="M225.56 635.84l20.78 12.33-15.45 8.67-20.77-12.32 15.44-8.68z"
              id="contactcard__box7"
            />
            <path
              fill="#c1272d"
              d="M141.53 635.84l20.78 12.33-15.44 8.67-20.78-12.32 15.44-8.68z"
              id="contactcard__box6"
            />
            <path
              fill="#ccc"
              d="M202.08 663.07l20.78 12.33-15.45 8.67-20.77-12.32 15.44-8.68z"
              id="contactcard__box5"
            />
            <path
              fill="#c1272d"
              d="M273.52 665.09l20.78 12.32-15.44 8.68-20.78-12.33 15.44-8.67z"
              id="contactcard__box4"
            />
            <path
              fill="#ccc"
              d="M322.31 695.16l20.78 12.32-15.44 8.68-20.78-12.32 15.44-8.68z"
              id="contactcard__box3"
            />
            <path
              fill="#c1272d"
              d="M624 528.48l20.78 12.33-15.45 8.67-20.77-12.32 15.44-8.68z"
              id="contactcard__box2"
            />
            <path
              fill="#ccc"
              d="M81.41 595.96l20.78 12.32-15.44 8.68-20.78-12.32 15.44-8.68z"
              id="contactcard__box1"
            />
          </motion.g>
          <motion.g id="contactcard__card1"
          
          animate={{x:[0,-10,0],y:[0,10,0]}}
          transition={{duration:5,loop:Infinity}}
          
          >
            <path
              d="M74.55 412l-47.46-27.4a2.44 2.44 0 00-2.45-.2L20 387l3.23 1.19v34.56c0 2.81 1.71 6.08 3.82 7.3l45.37 26.19v4l4.65-2.68a3.39 3.39 0 001.29-3v-35.31c.01-2.81-1.7-6.08-3.81-7.25z"
              fill="#1a1a1a"
            />
            <path
              d="M69.87 460.13l-47.47-27.4c-2.11-1.22-3.82-4.49-3.82-7.3v-35.29c0-2.81 1.71-4.1 3.82-2.89l47.47 27.41c2.1 1.21 3.81 4.48 3.81 7.29v35.29c0 2.82-1.68 4.11-3.81 2.89z"
              fill="#4d4d4d"
            />
            <g fill="#fff">
              <path d="M38.36 420.57c0 2-1.43 2.87-3.2 1.85a7.1 7.1 0 01-3.2-5.55c0-2 1.43-2.87 3.2-1.85a7.06 7.06 0 013.2 5.55zM48.07 426.17c0 2-1.44 2.87-3.21 1.85a7.08 7.08 0 01-3.2-5.55c0-2 1.43-2.87 3.2-1.85a7.09 7.09 0 013.21 5.55zM57.77 431.77c0 2-1.44 2.87-3.21 1.85a7.11 7.11 0 01-3.2-5.55c0-2 1.44-2.87 3.2-1.85a7.09 7.09 0 013.21 5.55z" />
            </g>
          </motion.g>
          <motion.g id="contactcard__card2"
          
          animate={{y:[0,20,0]}}
          transition={{duration:5,loop:Infinity}}
          
          >
            <path d="M608.54 69.63l-47.46-27.4a2.44 2.44 0 00-2.45-.2L554 44.66l3.23 1.18v34.57c0 2.81 1.71 6.08 3.82 7.29l45.36 26.19V118l4.66-2.68a3.37 3.37 0 001.29-3V76.93c0-2.82-1.71-6.08-3.82-7.3z" />
            <path
              d="M603.85 117.81l-47.46-27.4c-2.11-1.22-3.82-4.49-3.82-7.3V47.82c0-2.81 1.71-4.11 3.82-2.89l47.46 27.4c2.11 1.22 3.82 4.49 3.82 7.3v35.29c0 2.81-1.67 4.08-3.82 2.89z"
              fill="#333"
            />
            <g fill="#fff">
              <path d="M572.35 78.24c0 2.05-1.43 2.87-3.2 1.85a7.06 7.06 0 01-3.2-5.54c0-2 1.43-2.87 3.2-1.85a7.06 7.06 0 013.2 5.54zM582.05 83.85c0 2-1.43 2.86-3.2 1.84a7.06 7.06 0 01-3.2-5.54c0-2.05 1.43-2.87 3.2-1.85a7.06 7.06 0 013.2 5.55zM591.76 89.45c0 2-1.44 2.87-3.21 1.84a7.06 7.06 0 01-3.2-5.54c0-2 1.43-2.87 3.2-1.85a7.07 7.07 0 013.21 5.55z" />
            </g>
          </motion.g>
          <motion.g id="contactcard__five"
          
          animate={{scale:[0.7,1,0.7],y:[0,20,0]}}
          transition={{duration:5,loop:Infinity}}


          >
            <path
              d="M565.38 50.07c0-11.65-8.18-25.82-18.27-31.65-4.92-2.84-9.37-3.15-12.66-1.4l-.2.11a.41.41 0 01-.11.07l-6.36 3.66 3-.19a16.53 16.53 0 00-1.95 8.33c0 11.66 8.18 25.83 18.28 31.66a17.07 17.07 0 007.49 2.45c-.42.8-1.4 2.76-1.4 2.76l6.62-3.87.41-.24.3-.17h-.07c3.04-1.99 4.92-5.95 4.92-11.52z"
              fill="#911d22"
            />
            <ellipse
              cx={540.49}
              cy={43.34}
              rx={14.92}
              ry={25.84}
              transform="rotate(-30 540.529 43.334)"
              fill="#c1272d"
            />
            <path
              d="M539.94 54.88a11.18 11.18 0 01-2.48-1.88 7.91 7.91 0 01-1.57-2.33 11.7 11.7 0 01-.79-2.67 17.66 17.66 0 01-.23-3l3.36 1.94c0 .63 0 1.17.06 1.61a8.65 8.65 0 00.24 1.36 3.47 3.47 0 00.57 1.21 3.08 3.08 0 001 .84 1.59 1.59 0 00.65.23 1.15 1.15 0 00.48-.08.75.75 0 00.31-.44 4.09 4.09 0 00.2-.63 5.17 5.17 0 00.1-.92v-1-1.22-1.48a12.3 12.3 0 00-.14-1.27 4.93 4.93 0 00-.3-1.14 3.54 3.54 0 00-.54-.88 3.28 3.28 0 00-.85-.72 1.19 1.19 0 00-1.2-.13 1.61 1.61 0 00-.69 1.05l-2.94-1.7.16-12.74 9.08 5.25v3.6l-6.15-3.55-.21 5.33a1.57 1.57 0 011.1-.18 4.6 4.6 0 011.57.56 7.37 7.37 0 012 1.6 8 8 0 011.4 2.22 12.62 12.62 0 01.78 2.68 18.81 18.81 0 01.25 3.1 25.07 25.07 0 01-.13 2.65 8.44 8.44 0 01-.47 2 2.69 2.69 0 01-.92 1.32 2.18 2.18 0 01-1.51.28 5.7 5.7 0 01-2.19-.87z"
              fill="#fff"
            />
          </motion.g>
          <motion.path
        
            id="contactcard__tick1"
            d="M528 342.11L519.33 328a2.37 2.37 0 014-2.48l6.36 10.33 20.11-10.56a2.36 2.36 0 012.2 4.21z"
            fill="#c1272d"
          />
          <path
            d="M513.8 284.94c-4.54 0-9.72-2.34-13.78-4.68-12.27-7.08-18.49-16.59-18.49-28.26 0-6.58 2.33-11.55 6.57-14s9.72-2 15.41 1.31c10.91 6.3 19.78 21.67 19.78 34.26 0 5-1.54 8.41-4.58 10.16a9.67 9.67 0 01-4.91 1.21zm-19.72-44.08a7.45 7.45 0 00-3.78.95c-2.82 1.63-4.37 5.25-4.37 10.19 0 10 5.48 18.21 16.29 24.45 6.36 3.67 11.71 5 14.29 3.47 1.58-.91 2.38-3.05 2.38-6.35 0-11.19-7.88-24.85-17.58-30.45a14.85 14.85 0 00-7.23-2.26z"
            fill="#c1272d"
          />
          <path
            d="M530.92 265a2.22 2.22 0 01-1.71-.81c-10.86-13.26-32.44-23-32.66-23.05a2.2 2.2 0 011.78-4c.93.41 22.76 10.2 34.29 24.28a2.21 2.21 0 01-1.7 3.6z"
            fill="#c1272d"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;

